import { CustomerSupportInformationFormType } from 'components/customer-support-information/CustomerSupportInformationForm';

export const createCustomerSupportInformationInitialValues: Partial<CustomerSupportInformationFormType> = {};
